<template>
<div class="flex items-center justify-center gap-10">
    <LeftDots :number="number"/>
    <div class="number relative">
        <span class="flex items-center justify-center">{{ number }}</span>
    </div>
    <RightDots :number="number"/>
</div>
</template>

<script>
import LeftDots from "./Vector/LeftDots.vue";
import RightDots from "./Vector/RightDots.vue";

export default {
	name: "QuestionNumber",
	components: {RightDots, LeftDots},
	props: {
		number: Number
	}
};
</script>

<style scoped lang="scss">
.number {
    --size: 50px;
    --test-size: 24px;
    --border-radius: 10px;
    --border: 2px solid black;
    --shadow-offset: 6px;

    @media (min-width: 1024px) {
        --size: 54px;
        --test-size: 30px;
        --border-radius: 10px;
        --border: 4px solid black;
        --shadow-offset: 6.5px;
    }

    &::before {
        content: "";
        display: block;
        width: var(--size);
        height: var(--size);
        position: absolute;
        border-radius: var(--border-radius);
        left: var(--shadow-offset);
        top: var(--shadow-offset);
        background: var(--green);
        animation: move-shadow 3s infinite alternate ease-in-out;
    }

    span {
        position: relative;
        z-index: 2;
        width: var(--size);
        height: var(--size);
        font-weight: 900;
        font-size: var(--test-size);
        color: black;
        border: var(--border);
        border-radius: var(--border-radius);
    }

    @keyframes move-shadow {
        to {
            transform: translate(calc(var(--shadow-offset) * 1.1), calc(var(--shadow-offset) * 1.1)) scale(1.01);
        }
    }

}
</style>
